import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function VendorsIndex() {
  const [vendors, setVendors] = useState([]);
  useEffect(() => { api.get("/vendors?status=approved").then((r) => setVendors(r.data)); }, []);
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">The Roster · {vendors.length} Houses</p>
      <h1 className="font-serif text-6xl md:text-7xl mt-2 mb-12">All Vendors.</h1>
      <div className="grid md:grid-cols-3 gap-10">
        {vendors.map((v) => (
          <Link to={`/vendor/${v.slug}`} key={v.id} className="group">
            <div className="aspect-[4/3] bg-secondary overflow-hidden">
              {v.banner_url && <img src={v.banner_url} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />}
            </div>
            <div className="mt-4">
              <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Vendor</p>
              <h3 className="font-serif text-2xl mt-1">{v.store_name}</h3>
              <p className="text-sm text-muted-foreground mt-2">{v.tagline}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
